<div class="modal fade login-modal" id="loginModal" tabindex="-1" aria-labelledby="loginModalLabel">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content glass-card">
      <div class="modal-body p-4">
        <div class="modal-heading text-center mb-4">
          <div class="brand-icon mb-3">
            <i class="fa-solid fa-satellite-dish"></i>
          </div>
          <h3 id="loginModalLabel" class="mb-2">مرحبًا بعودتك</h3>
          <p class="lead mb-0">سجّل الدخول</p>
        </div>

        <form [formGroup]="form" (ngSubmit)="submit()" novalidate class="login-form">
          <div class="form-floating mb-3 input-with-icon" [ngClass]="{'is-invalid': (submitted || f['email'].touched) && f['email'].invalid}">
            <input
              type="email"
              id="loginEmail"
              class="form-control"
              placeholder="name@example.com"
              formControlName="email"
              [class.is-invalid]="(submitted || f['email'].touched) && f['email'].invalid"
            />
            <label for="loginEmail">البريد الإلكتروني</label>
            <i class="fa-solid fa-envelope"></i>
            <div class="invalid-feedback d-block" *ngIf="submitted || f['email'].touched">
              @if (f['email'].errors?.['required']) { البريد الإلكتروني مطلوب }
              @else if (f['email'].errors?.['email']) { يرجى إدخال بريد إلكتروني صالح }
            </div>
          </div>

          <div class="form-floating mb-3 input-with-icon password-field" [ngClass]="{'is-invalid': (submitted || f['password'].touched) && f['password'].invalid}">
            <input
              [type]="passwordVisible ? 'text' : 'password'"
              id="loginPassword"
              class="form-control"
              placeholder="••••••••"
              formControlName="password"
              [class.is-invalid]="(submitted || f['password'].touched) && f['password'].invalid"
            />
            <label for="loginPassword">كلمة المرور</label>
            <i class="fa-solid fa-lock"></i>
            <button type="button" class="toggle-password" (click)="togglePasswordVisibility()" aria-label="Toggle password visibility">
              <i class="fa-solid" [class.fa-eye]="!passwordVisible" [class.fa-eye-slash]="passwordVisible"></i>
            </button>
            <div class="invalid-feedback d-block" *ngIf="submitted || f['password'].touched">
              @if (f['password'].errors?.['required']) { كلمة المرور مطلوبة }
              @else if (f['password'].errors?.['minlength']) { يجب أن تتكون كلمة المرور من 6 أحرف على الأقل }
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="rememberMe" formControlName="rememberMe">
              <label class="form-check-label" for="rememberMe">
                تذكرني لاحقًا
              </label>
            </div>
            <a href="#" class="text-decoration-none forgot-link">هل نسيت كلمة المرور؟</a>
          </div>

          <div class="alert alert-danger border-0 py-2 px-3" *ngIf="error">
            <i class="fa-solid fa-circle-exclamation me-2"></i> {{ error }}
          </div>

          <button class="btn btn-login w-100 mt-3" type="submit" [disabled]="loading">
            <span *ngIf="!loading">
              <i class="fa-solid fa-arrow-right-to-bracket ms-2"></i>
              تسجيل الدخول
            </span>
            <span *ngIf="loading">
              <i class="fa-solid fa-circle-notch fa-spin ms-2"></i>
              جاري التحقق...
            </span>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>